import { render, staticRenderFns } from "./PromoCompareTemplateA6.vue?vue&type=template&id=7e75281c"
import script from "./PromoCompareTemplateA6.vue?vue&type=script&lang=js"
export * from "./PromoCompareTemplateA6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports